import profile from "../img/profile.jpg"

export let colors = ["rgb(0,255,164)", "rgb(166,104,255)"];

export let singlePage = false;

export const info = {
    firstName: "Bhagavath",
    lastName: "Raamsingh",
    initials: "🤖",
    position: "a Technical Lead & Cloud Architect",
    selfPortrait: profile,
    gradient: `-webkit-linear-gradient(135deg, ${colors})`,
    baseColor: colors[0],
    miniBio: [
        {
            emoji: "\u2601\ufe0f",
            text: "14+ years in Cloud, AI, DevOps, RPA and Platform engineering"
        },
        {
            emoji: "\u2699\ufe0f",
            text: "Building GxP & SOX compliant automations and AI-powered platforms"
        },
        {
            emoji: "\ud83d\udcbc",
            text: "Technical Lead & Architect at Wipro"
        },
        {
            emoji: "\ud83d\udce7",
            text: "contact@bhagavathsingh.com"
        }
    ],
    socials: [
        {
            link: "mailto:contact@bhagavathsingh.com",
            icon: "fa fa-envelope",
            label: "email"
        },
        {
            link: "https://www.instagram.com/rbhagavathsingh/",
            icon: "fa fa-instagram",
            label: "instagram"
        },
        {
            link: "https://www.linkedin.com/in/bhagavathsinghraamsingh/",
            icon: "fa fa-linkedin",
            label: "linkedin"
        }
    ],
    bio: "Seasoned IT professional with 14+ years of experience in platform and system administration, cloud management, and DevOps engineering. I specialize in leading large-scale cloud migrations, designing scalable AWS architectures, and delivering enterprise automation that improves operational efficiency and reduces manual workloads. My recent work focuses on compliant RPA platforms, incident resilience, and GenAI-assisted tooling for global teams.",
    skills: {
        proficientWith: [
            "AWS",
            "DevOps",
            "Cloud Migration",
            "System Administration",
            "Python",
            "Java",
            "C#",
            "Blazor",
            "Jenkins",
            "CI/CD",
            "Blue Prism",
            "LangFlow",
            "GenAI",
            "AI Agents",
        ],
        exposedTo: [
            "Azure",
            "PowerApps",
            "Automation Anywhere",
            "UiPath",
            "Splunk"
        ]
    },
    hobbies: [
        {
            label: "photography",
            emoji: "\ud83d\udcf8"
        },
        {
            label: "games",
            emoji: "\ud83c\udfae"
        },
        {
            label: "home Labing",
            emoji: "\ud83d\udda5\ufe0f"
        }
    ],
    experience: [
        {
            role: "Technical Lead & Architect",
            company: "Johnson & Johnson",
            location: "New Jersey, USA / Ontario, Canada",
            period: "Feb 2018 - Present",
            accent: "Automation Leadership",
            highlights: [
                "Built an enterprise RPA administration platform with Blazor, WinForms, SignalR, and WebAPI, reducing manual operational effort by 90%.",
                "Integrated GenAI agents with Blue Prism and LangFlow to automate service requests, change requests, and operational analysis.",
                "Led migration of on-premise applications to cloud infrastructure, cutting annual hosting cost by more than 30%.",
                "Mentored a global team of 10+ engineers and acted as the single point of contact for intelligent automation operations."
            ]
        },
        {
            role: "Project Engineer",
            company: "Capital One CRS",
            location: "Chicago, USA",
            period: "Jan 2015 - Jan 2018",
            accent: "Cloud and Incident Operations",
            highlights: [
                "Served as the first point of escalation for Apache, WebSphere, AWS infrastructure, and customer-facing web platforms.",
                "Led root cause analysis for major incidents and coordinated critical production changes with cross-functional stakeholders.",
                "Built scripts and automation solutions to optimize support tasks and business workflows.",
                "Drove Blue Prism and AWS-based process improvements that improved service quality and reduced downtime."
            ]
        },
        {
            role: "Project Engineer",
            company: "Capital One",
            location: "Richmond, USA",
            period: "Aug 2012 - Dec 2014",
            accent: "Systems Administration",
            highlights: [
                "Managed day-to-day Unix and server operations, backups, monitoring, and batch scheduling for production systems.",
                "Resolved recurring UNIX script failures and production issues through debugging, tuning, and service improvement plans.",
                "Automated server jobs and reporting through scripting while maintaining documentation and operational metrics.",
                "Closed severity incidents within SLA targets and improved process reliability across infrastructure operations."
            ]
        },
    ],
    certifications: [
        "Blue Prism Certified Installation Engineer (V6)",
        "Blue Prism Certified Developer Associate",
        "AWS Certified Solutions Architect - Associate",
        "AWS Certified Developer - Associate",
        "IBM - Python for Data Science, AI & Development",
        "Vanderbilt University - AI Agents with Model Context Protocol"
    ],
    education: [
        {
            degree: "Master of Engineering (M.E.) in Mechatronics Engineering",
            school: "Madras Institute of Technology, Chennai"
        },
        {
            degree: "Bachelor of Engineering (B.E.) in Electrical & Electronics Engineering",
            school: "Anna University, Chennai"
        }
    ]
}
